import {FC, useState, useEffect, Fragment} from 'react'

import {Col, Form, Modal, Row} from 'react-bootstrap'
import Api from '../../../thesis-and-dissertations/helpers/api'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'
const api = new Api()

type Props = {
  showUpdateProfileModal: boolean
}
const UpdateProfileContent: FC<Props> = ({showUpdateProfileModal}) => {
  const navigate = useNavigate()
  const [showModal, setShowModal] = useState(false)
  const [formData, setFormData] = useState<any>({})
  const [errors, setErrors] = useState<any>({})
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setShowModal(showUpdateProfileModal)
  }, [showUpdateProfileModal])

  const handleCloseModal = () => {
    setShowModal(false)
    setFormData({})
  }

  const handleInput = (e: any, name: string) => {
    setFormData({...formData, [name]: e.target.value})
    setErrors({})
  }

  const updateProfile = () => {
    setIsLoading(true)
    api
      .updateProfile(formData)
      .then((response: any) => {
        setIsLoading(false)
        const {data, status} = response
        toast.success(data?.meta?.message)
        setShowModal(false)
      })
      .catch((error: any) => {
        setIsLoading(false)
        const {data, status} = error.response
        setErrors(data?.meta?.error)

        handleApiError(error, navigate)
        toast.error(data?.meta?.message)
      })
  }

  return (
    <Modal show={showModal} centered size='lg'>
      <div className='p-10'>
        <p className='h4 mt-5'>Update Profil</p>
        <p className='mb-8'>
          Lengkapi data berikut: NIK, Email Alternatif, No. Handphone, Status Pekerjaan, Nomor
          Rekening Mandiri, Nama Sesuai Rekening, dan Nama Bank
        </p>
        <Form>
          <Row>
            <Col md={12}>
              <Form.Group className={'mb-6'}>
                <Form.Label>
                  NIK<i className='text-danger'>*</i>
                </Form.Label>
                <Form.Control
                  type='text'
                  inputMode='numeric'
                  maxLength={16}
                  value={formData.id_card_number}
                  onChange={(e) => {
                    const nikNumber = e.target.value.replace(/\D/g, '') // hapus semua non-digit
                    if (nikNumber.length > 16) {
                      return
                    }

                    setFormData((prev: any) => ({
                      ...prev,
                      id_card_number: nikNumber,
                    }))
                  }}
                  placeholder='Masukan NIK sesuai KTP'
                />
                {errors?.id_card_number ? (
                  <p className='text-danger mt-1'>{errors?.id_card_number}</p>
                ) : null}
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className={'mb-6'}>
                <Form.Label>
                  Email Alternatif<i className='text-danger'>*</i>
                </Form.Label>
                <Form.Control
                  type='text'
                  onChange={(value) => handleInput(value, 'email')}
                  placeholder='Masukan email alternatif'
                />
                {errors?.email ? <p className='text-danger mt-1'>{errors?.email}</p> : null}
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className={'mb-6'}>
                <Form.Label>
                  No. Handphone<i className='text-danger'>*</i>
                </Form.Label>
                <Form.Control
                  type='number'
                  value={formData.phone_number}
                  onChange={(e) => {
                    const phoneNumber = e.target.value.replace(/\D/g, '') // hapus semua non-digit
                    if (phoneNumber.length > 15) {
                      return
                    }

                    setFormData((prev: any) => ({
                      ...prev,
                      phone_number: phoneNumber,
                    }))
                  }}
                  name={'JudulTugasAkhir'}
                  placeholder='No Whatsapp'
                />
                {errors?.phone_number ? (
                  <p className='text-danger mt-1'>{errors?.phone_number}</p>
                ) : null}
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className={'mb-6'}>
                <Form.Label>
                  Status Pekerjaan<i className='text-danger'>*</i>
                </Form.Label>

                <Form.Select name='is_kerja' onChange={(value) => handleInput(value, 'is_kerja')}>
                  <option value=''>-- Pilih Status --</option>
                  <option value={1}>Sudah Bekerja</option>
                  <option value={0}>Belum Bekerja</option>
                </Form.Select>
                {errors?.is_kerja ? <p className='text-danger mt-1'>{errors?.is_kerja}</p> : null}
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className={'mb-6'}>
                <Form.Label>
                  Rekening (Diutamakan Mandiri)<i className='text-danger'>*</i>
                </Form.Label>
                <Form.Control
                  type='text'
                  inputMode='numeric'
                  value={formData.no_rekening}
                  onChange={(e) => {
                    const accountNumber = e.target.value.replace(/\D/g, '') // hapus semua non-digit
                    if (accountNumber.length > 20) {
                      return
                    }

                    setFormData((prev: any) => ({
                      ...prev,
                      no_rekening: accountNumber,
                    }))
                  }}
                  placeholder='Masukan nomor rekening Bank Mandiri'
                />
                {errors?.no_rekening ? (
                  <p className='text-danger mt-1'>{errors?.no_rekening}</p>
                ) : null}
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className={'mb-6'}>
                <Form.Label>
                  Nama Sesuai Rekening<i className='text-danger'>*</i>
                </Form.Label>
                <Form.Control
                  type='text'
                  value={formData.nama_rekening}
                  onChange={(e) => {
                    setFormData((prev: any) => ({
                      ...prev,
                      nama_rekening: e.target.value,
                    }))
                  }}
                  placeholder='Masukan nama sesuai rekening'
                />
                {errors?.nama_rekening ? (
                  <p className='text-danger mt-1'>{errors?.nama_rekening}</p>
                ) : null}
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className={'mb-6'}>
                <Form.Label>
                  Nama Bank
                </Form.Label>
                <Form.Select
                  value={formData.nama_bank}
                  onChange={(e) => {
                    setFormData((prev: any) => ({
                      ...prev,
                      nama_bank: e.target.value,
                    }))
                  }}
                >
                  <option value=''>-- Pilih Bank --</option>
                  <option value='Bank Mandiri'>Bank Mandiri</option>
                  <option value='Bank Rakyat Indonesia (BRI)'>Bank Rakyat Indonesia (BRI)</option>
                  <option value='Bank Central Asia (BCA)'>Bank Central Asia (BCA)</option>
                  <option value='Bank Negara Indonesia (BNI)'>Bank Negara Indonesia (BNI)</option>
                  <option value='Bank Tabungan Negara (BTN)'>Bank Tabungan Negara (BTN)</option>
                  <option value='Bank CIMB Niaga'>Bank CIMB Niaga</option>
                  <option value='Bank Permata'>Bank Permata</option>
                  <option value='Bank Danamon'>Bank Danamon</option>
                  <option value='Bank Syariah Indonesia (BSI)'>Bank Syariah Indonesia (BSI)</option>
                  <option value='Bank OCBC NISP'>Bank OCBC NISP</option>
                  <option value='Bank Maybank'>Bank Maybank</option>
                  <option value='Bank Panin'>Bank Panin</option>
                  <option value='Bank UOB Indonesia'>Bank UOB Indonesia</option>
                  <option value='Bank BNI Syariah'>Bank BNI Syariah</option>
                  <option value='Bank Mega'>Bank Mega</option>
                  <option value='Bank Bukopin'>Bank Bukopin</option>
                  <option value='Bank Sinarmas'>Bank Sinarmas</option>
                  <option value='Bank DKI'>Bank DKI</option>
                  <option value='Bank BJB (Jawa Barat)'>Bank BJB (Jawa Barat)</option>
                  <option value='Bank Jatim'>Bank Jatim</option>
                  <option value='Bank Lainnya'>Bank Lainnya</option>
                </Form.Select>
                {errors?.nama_bank ? (
                  <p className='text-danger mt-1'>{errors?.nama_bank}</p>
                ) : null}
              </Form.Group>
            </Col>
          </Row>
        </Form>

        <button
          type="button"
          className='btn btn-primary btn-sm w-100 mt-3'
          style={{background: ' var(--Primary-L-500, #F95E2F)'}}
          onClick={updateProfile}
          disabled={isLoading}
        >
          {isLoading ? 'Loading...' : 'Simpan'}
        </button>

        {/* <button
          className='btn btn-sm w-100 mt-3 text-primary'
          style={{border: '1px solid var(--Primary-L-500, #F95E2F)'}}
          onClick={handleCloseModal}
        >
          Batal
        </button> */}
      </div>
    </Modal>
  )
}

const UpdateProfileModal: FC<Props> = ({showUpdateProfileModal}) => {
  return <UpdateProfileContent showUpdateProfileModal={showUpdateProfileModal} />
}

export default UpdateProfileModal
